<script lang="ts">
  import { getUiclContext, useActions, type HTMLActionArray } from "#lib"
  import type { BaseProps } from "#lib/internal/types"
  import { cn } from "#lib/utils"
  import type { VariantProps } from "class-variance-authority"
  import type { ClassValue } from "class-variance-authority/types"
  import type {
    HTMLAnchorAttributes,
    HTMLButtonAttributes,
  } from "svelte/elements"
  import { buttonVariants } from "."

  let className: ClassValue | undefined | null = undefined
  export { className as class }
  export let href: HTMLAnchorAttributes["href"] = undefined
  export let type: HTMLButtonAttributes["type"] = "button"
  export let variant: VariantProps<typeof buttonVariants>["variant"] = "default"
  // TODO: after consumers are comfortable using the new designs, make default value "medium"
  export let size: VariantProps<typeof buttonVariants>["size"] = undefined
  export let ref: HTMLAnchorElement | HTMLButtonElement | null = null
  /**
   * default to _blank if href is truthy
   */
  export let target: HTMLAnchorAttributes["target"] = href
    ? "_blank"
    : undefined

  type $$Props = Omit<BaseProps<"button"> & BaseProps<"a">, "class"> & {
    class?: ClassValue | null
    variant?: VariantProps<typeof buttonVariants>["variant"]
    size?: VariantProps<typeof buttonVariants>["size"]
    use?: HTMLActionArray
    ref?: HTMLAnchorElement | HTMLButtonElement | null
    children?: any // make svelte 5 stuff happy
  }

  const v2 = !!getUiclContext()?.v2
</script>

<svelte:element
  this={href ? "a" : "button"}
  type={href ? undefined : type}
  {href}
  class={cn(buttonVariants({ variant, size, v2, className }))}
  use:useActions={$$restProps.use}
  {...$$restProps}
  role={href ? "link" : "button"}
  bind:this={ref}
  {target}
  on:click
  on:change
  on:keydown
  on:keyup
  on:mouseenter
  on:mouseleave
  on:contextmenu
  data-variant={variant}
>
  <slot />
</svelte:element>

<style lang="postcss">
  .v2-transitions {
    transition-property: background-color, transform, translate, scale, rotate;
    transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
  }
</style>
